import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import React from 'react';
import {
  BreadcrumbChevron,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbsContainer,
  BreadcrumbItemContainer,
} from './FaqBreadcrumbs.style';
import { FaqBreadCrumb } from './FaqPageContainer';

interface FaqBreadcrumbsProps {
  breadcrumbs: FaqBreadCrumb[];
  onClearQuery: () => void;
  searchItem?: boolean;
}

const FaqBreadcrumbs: React.FC<FaqBreadcrumbsProps> = ({ breadcrumbs, searchItem, onClearQuery }) => {
  return (
    <BreadcrumbsContainer
      data-testid="faq-breadcrumbs"
      searchItem={searchItem}
      vocab={!searchItem ? 'https://schema.org/' : undefined}
      typeof={!searchItem ? 'BreadcrumbList' : undefined}
    >
      {breadcrumbs.map((bc, i) => (
        <BreadcrumbItemContainer
          key={`${bc.url}-${bc.title}`}
          data-testid="faq-breadcrumb"
          property={!searchItem ? 'itemListElement' : undefined}
          typeof={!searchItem ? 'ListItem' : undefined}
        >
          {bc.url ? (
            <BreadcrumbLink
              prefetch={false}
              href={bc.url}
              property={!searchItem ? 'item' : undefined}
              typeof={!searchItem ? 'WebPage' : undefined}
              $link
              data-testid="faq-breadcrumb-link"
              // need to wipe query params, as that FAQSearch component will not unmount
              // to remove the state, otherwise it will re-apply the queryparam.
              // so we need to wipe it here
              onClick={onClearQuery}
            >
              {/* eslint-disable-next-line react/no-unknown-property */}
              <span property={!searchItem ? 'name' : undefined} data-testid="faq-breadcrumb-title">
                {bc.title}
              </span>
            </BreadcrumbLink>
          ) : (
            <BreadcrumbItem property={!searchItem ? 'name' : undefined} data-testid="faq-breadcrumb-title">
              {bc.title}
            </BreadcrumbItem>
          )}
          {!searchItem && <meta property="position" content={String(i + 1)} data-testid="faq-breadcrumb-meta" />}
          {i !== breadcrumbs.length - 1 && <BreadcrumbChevron testID="faq-breadcrumb-divider" icon={faChevronRight} />}
        </BreadcrumbItemContainer>
      ))}
    </BreadcrumbsContainer>
  );
};

export default FaqBreadcrumbs;
